// extracted by mini-css-extract-plugin
module.exports = {"container":"groupInfo_container__2fUdm"};